export default __webpack_public_path__ + "static/media/487.e8329091.png";